// extracted by mini-css-extract-plugin
export var dividerLine = "_86-3";
export var itemImage = "_86-9";
export var lightDivider = "_86-4";
export var modalContent = "_86-5";
export var modalContentCompact = "_86-6";
export var productCard = "_86-a";
export var productImage = "_86-b";
export var productImageCompact = "_86-7";
export var productImagePlaceholder = "_86-c";
export var productImagePlaceholderCompact = "_86-8";
export var progressBarBackground = "_86-1";
export var progressBarContainer = "_86-0";
export var progressBarFill = "_86-2";